import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from '../../app.config';
@Component({
  selector: 'app-startpuzzle',
  templateUrl: './startpuzzle.component.html',
  styleUrls: ['./startpuzzle.component.css']
})
export class StartpuzzleComponent implements OnInit {
 
  sopId : number;

  constructor(public appConfig: AppConfig,private router: Router,private activatedRoute: ActivatedRoute,) { }

  ngOnInit() {
    this.sopId = this.activatedRoute.snapshot.params.id;
  }
 
    childData(data){
      switch(data.key) {
        case 'backToElearning':
          this.router.navigate(['/elearning']);
        break;
        
      }
    }

}
